import {
  Component,
  OnInit,
  OnDestroy,
} from '@angular/core'
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
} from '@angular/router'
import { Subscription } from 'rxjs'

@Component({
  selector: '[licensesTabs]',
  templateUrl: './licenses-tabs.component.html',
  styleUrls: ['./licenses-tabs.component.css'],
})
export class LicensesTabsComponent implements OnInit, OnDestroy {
  visible = false
  router$: Subscription
  private type$: Subscription
  public type: string

  constructor(public router: Router, public route: ActivatedRoute) {}

  ngOnInit() {
    const routeParts = this.router.url.split('/')

    this.visible = routeParts[1] === 'licenses' && routeParts.length === 3
    this.type = routeParts[2]

    this.router$ = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const routeParts = this.router.url.split('/')

        this.visible = routeParts[1] === 'licenses' && routeParts.length === 3
        this.type = routeParts[2]
      }
    })
  }

  ngOnDestroy(): void {
    this.router$.unsubscribe()
  }
}